const login = {
  page: {
    title: 'Ihr Login',
    subtitle: 'Bitte melden Sie sich hier mit Ihren Zugangsdaten an',
  },
  newHere: 'Neu hier?',
  join: 'Jetzt registrieren',
  forgotPassword: 'Passwort vergessen?',
  validation: {
    global: {
      notFound: 'Zu dieser E-Mail-Adresse konnte kein verifiziertes Kundenkonto gefunden werden.',
      invalidCredentials: 'Passwort ungültig',
      notEnabled: 'Zu dieser E-Mail-Adresse konnte kein verifiziertes Kundenkonto gefunden werden.',
      ownershipError: 'Ihre Sitzung ist abgelaufen, daher wurde Ihr Warenkorb aus Sicherheitsgründen gelöscht. Bitte melden Sie sich erneut an.',
    },
  },
}

export default login
